<template>
  <div class="forget-login-wrapper">
    <div class="forget-login-content">
      <div class="forget-login-logo">
        <img src="../assets/images/init-logo.png" alt="" />
      </div>
      <h2 class="forget-login-title">忘记密码</h2>
      <div class="step">
        <div class="step-item active">1.验证手机号</div>
        <div class="step-item" :class="[!active ? 'no-active' : 'active']">
          2.设置密码
        </div>
      </div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item v-show="active == 0" prop="phoneNumber">
          <el-input
            class="forget-login-input"
            placeholder="请输入手机号"
            v-model="ruleForm.phoneNumber"
          ></el-input>
        </el-form-item>
        <el-form-item v-show="active == 0" prop="code">
          <el-input
            class="forget-login-input"
            placeholder="请输入验证码"
            v-model="ruleForm.code"
          >
          </el-input>
          <div class="btn po" @click="getCode" v-if="show">获取验证码</div>
          <div class="po not" v-show="!show">{{ count }}S后重试</div>
        </el-form-item>
        <el-form-item v-if="active == 1" prop="setPassword">
          <el-input
            class="forget-login-input"
            type="password"
            placeholder="设置新密码,6-16位的字母或数字组合"
            v-model="ruleForm.setPassword"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="active == 1" prop="checkPass">
          <el-input
            class="forget-login-input"
            type="password"
            placeholder="验证新密码"
            v-model="ruleForm.checkPass"
          ></el-input>
        </el-form-item>
        <el-form-item class="sure-login">
          <el-button v-show="active == 0" @click="$router.push('/')">
            返回
          </el-button>
          <el-button v-show="active == 1" @click="last(active - 1)"
            >上一步</el-button
          >
          <el-button
            type="primary"
            v-show="active == 1"
            :loading="loading"
            @click="submitLoging('ruleForm')"
            >完成并登录</el-button
          >
          <el-button
            v-show="active == 0"
            :disabled="disabled || phoneValidate"
            @click="next(active + 1)"
            >下一步</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import Http from "../lib/Http";
export default {
  name: "ForgetPassword",
  data() {
    let that = this;
    var validatePass = (rule, value, callback) => {
      //验证密码
      if (value === "") {
        callback(new Error("请输入密码"));
        // this.disabled = true
      }else if (this.pass) {
        this.pass = 0;
        callback(new Error(this.passErrMsg));
      } else {
        if (that.ruleForm.checkPass !== "") {
          that.$refs.ruleForm.validateField("checkPass");
        }
        // this.disabled = false
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      //二次验证密码
      if (value === "") {
        callback(new Error("请再次输入密码"));
        this.disabled = true;
      } else if (value !== that.ruleForm.setPassword) {
        callback(new Error("两次输入密码不一致!"));
        this.disabled = true;
      } else {
        this.disabled = false;
        callback();
      }
    };
    var validateCode = (rule, value, callback) => {
      //验证验证码
      if (value == "") {
        callback(new Error("请输入验证码"));
        this.disabled = true;
      } else if (this.newCode) {
        console.log(this.newCode);
        this.newCode = 0;
        callback(new Error(this.newCodeErr));
        this.disabled = true;
      } else {
        this.disabled = false;
        callback();
      }
    };
    var validatePhone = (rule, value, callback) => {
      //验证手机
      let reg = /^1[3-9]\d{9}$/;
      if (value == "") {
        this.phoneValidate = true;
        callback(new Error("请输入手机号"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的手机号"));
        this.phoneValidate = true;
      } else if (this.newPhone) {
        this.newPhone = 0;
        callback(new Error(this.newPhoneErr));
      } else {
        this.phoneValidate = false;
        callback();
      }
    };
    return {
      ruleForm: {
        phoneNumber: "",
        code: "",
        setPassword: "",
        checkPass: "",
      },
      active: 0,
      rules: {
        setPassword: [
          { validator: validatePass, trigger: "blur" },
          {
            min: 3,
            max: 10,
            message: "长度在 6 到 16 个字符",
            trigger: "blur",
          },
        ],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
        phoneNumber: [
          { required: true, validator: validatePhone, trigger: "blur" },
        ],
        code: [{ required: true, validator: validateCode, trigger: "blur" }],
      },
      show: true,
      count: 60,
      timer: null,
      pass: 0,
      passErrMsg: "",
      newCodeErr: "",
      newCode: 0, //获取的验证码
      newPhoneErr: "",
      newPhone: 0, //获取的新手机号
      disabled: true, //验证吗禁用
      phoneValidate: true, //手机禁用
      loading: false,
      updateToken: "",
    };
  },
  activated() {
    this.ruleForm.phoneNumber = "";
    this.ruleForm.code = "";
    this.ruleForm.setPassword = "";
    this.ruleForm.checkPass = "";
    this.$nextTick(() => {
      this.$refs.ruleForm.clearValidate();
    });
  },
  methods: {
    next(val) {
      let sendObj = {
        captcha: this.ruleForm.code,
        clientType: 1,
        username: this.ruleForm.phoneNumber,
        validType: 1,
      };
      let _this = this;
      //下一步
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (val > 3) {
            return;
          }
          Http.zsyPostHttp(
            "/auth/teacher/sms/login",
            sendObj,
            (ok) => {
              _this.active = val;
              _this.updateToken = ok.data.updateToken;
            },
            (fail) => {
              if (fail.errMsg == "验证码已过期，请重新获取") {
                _this.newCode = 1;
                _this.newCodeErr = "验证码已过期";
                _this.$nextTick(() => {
                  _this.$refs.ruleForm.validateField("code");
                });
              } else if (fail.errMsg == "验证码不正确") {
                _this.newCode = 1;
                _this.newCodeErr = "验证码不正确";
                _this.$nextTick(() => {
                  _this.$refs.ruleForm.validateField("code");
                });
              } else if (fail.errMsg == "登录手机号格式错误") {
                _this.newPhone = 1;
                _this.newPhoneErr = "手机号格式错误";
                _this.$nextTick(() => {
                  _this.$refs.ruleForm.validateField("phoneNumber");
                });
              }
            }
          );
        }
      });
    },
    last(val) {
      this.active = val;
    },
    submitLoging() {
      console.log(this.ruleForm.checkPass, this.ruleForm.setPassword);

      if (!this.ruleForm.checkPass) {
        this.$refs.ruleForm.validateField("checkPass");
        return;
      } else if (!this.ruleForm.setPassword) {
        this.$refs.ruleForm.validateField("setPassword");
        return;
      }
      let sendObj = {
        confirm: this.ruleForm.checkPass,
        clientType: 1,
        password: this.ruleForm.setPassword,
        updateToken: this.updateToken,
      };
      let _this = this;
      Http.zsyPutHttp(
        "/auth/teacher/change/password",
        sendObj,
        (ok) => {
          window.location.href = `${Http.JUMP_TEACHER_URL().hm}/?portal=${
            ok.data.portalToken
          }`;
        },
        (fail) => {
          if (fail.errMsg == "新密码太简单，请更换安全的密码！") {
            _this.pass = 1;
            _this.passErrMsg = "新密码太简单";
            _this.$nextTick(() => {
              _this.$refs.ruleForm.validateField("setPassword");
            });
          } else if (
            fail.errMsg == "密码格式错误:密码位数6~16位，只能数字和字母组合。"
          ) {
            _this.pass = 1;
            _this.passErrMsg = "密码格式错误";
            _this.$nextTick(() => {
              _this.$refs.ruleForm.validateField("setPassword");
            });
          } else if (fail.errMsg === "授权已超时，请重新开始验证！") {
            this.$message.error("授权已超时，请重新开始验证！");
            setTimeout(() => {
              _this.$router.push("/");
            }, 2000);
          }
        }
      );
    },
    teacherCode() {
      const TIME_COUNT = 60;
      let _this = this;
      Http.zsyGetHttp(
        `/auth/captcha/teacher-sms/${this.ruleForm.phoneNumber}`,
        {},
        (ok) => {
          if (!_this.timer) {
            _this.count = TIME_COUNT;
            _this.show = false;
            _this.timer = setInterval(() => {
              if (_this.count > 0 && _this.count <= TIME_COUNT) {
                _this.count--;
              } else {
                _this.show = true;
                clearInterval(_this.timer);
                _this.timer = null;
              }
            }, 1000);
          }
        },
        (fail) => {
          if (fail.errMsg == "教师账号不存在，请检查或者联系学管！") {
            _this.newPhone = 1;
            _this.newPhoneErr = "账号不存在";
            _this.$nextTick(() => {
              _this.$refs.ruleForm.validateField("phoneNumber");
            });
          }
        }
      );
    },
    getCode() {
      this.$refs.ruleForm.validateField("phoneNumber");
      if (this.phoneValidate) {
        return;
      }
      if (this.$route.query.from === "teacher") {
        this.teacherCode();
      }
    },
  },
};
</script>
<style>
.el-form-item__error {
  padding-top: 7px;
  /* color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  top: 21%;
  right: 15% !important;
  left: unset; */
}
</style>
<style lang="less" scoped>
.btn,
.not {
  width: 86px;
  height: 36px;
  text-align: center;
  line-height: 36px;
  border-radius: 4px;
}
.btn {
  color: #ffffff;
  background: #3ecdba;
  cursor: pointer;
}
.not {
  background: #eeeeee;
  color: #666666;
  cursor: not-allowed;
}
.po {
  position: absolute;
  right: 0;
  top: 0;
}

.no-active {
  font-weight: 600;
  font-size: 14px;
  background: url("../assets/img/step-no-acitve.png") no-repeat 0;
}
.active {
  color: #3ecdba;
  font-weight: 600;
  font-size: 14px;
  background: url("../assets/img/step-acitve.png") no-repeat 0;
}
.forget-login-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: url("../assets/images/bg-main.png") top;

  .forget-login-logo {
    position: absolute;
    top: -74px;
    left: 50%;
    transform: translateX(-50%);
    width: 148px;
    height: 148px;
    border-radius: 50%;
    background: #ffffff;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .forget-login-content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #ffffff;
    border-radius: 4px;
    width: 600px;
    padding: 90px 120px 60px 120px;
    box-sizing: border-box;
    .forget-login-title {
      font-size: 30px;
      color: #333333;
      text-align: center;
      font-weight: 400;
    }
    .step {
      display: flex;
      justify-content: center;
      margin: 20px 20px 48px 0;
      .step-item {
        width: 150px;
        height: 36px;
        line-height: 36px;
        text-align: center;
      }
    }
    .forget-login-input {
      /deep/ .el-input__inner {
        border-left: 0; // 去除未选中状态边框
        border-right: 0; // 去除未选中状态边框
        border-top: 0;
        border-bottom: 1px solid #eeeeee;
        outline: none; // 去除选中状态边框
        border-radius: 0;
        // background-color: rgba(0, 0, 0, 0); // 透明背景
      }
    }
  }
  .sure-login {
    /deep/ .el-form-item__content {
      text-align: center;
    }
  }
}
</style>


// WEBPACK FOOTER //
// ForgetPassWord.vue?161e7098